import {Injectable} from '@angular/core';
import {CanActivate, Router} from '@angular/router';
import {UtilsService} from '../utils/utils.service';

@Injectable()
export class AdminGuard implements CanActivate {

  constructor(public _router: Router, private _utils: UtilsService) {
  }

  canActivate() {
    if (this._utils.getUsuario() && this._utils.getUsuario()['papeis']['super'] === 1) {
      return true;
    } else {
      this._router.navigate(['/login']);
      return false;
    }
  }
}
